import { createAction } from "redux-actions";

export const getSiteGroups = createAction("GET_SITE_GROUPS");
export const setSiteGroups = createAction("SET_SITE_GROUPS");
